<script>
    import {createEventDispatcher, afterUpdate} from 'svelte';
    import { hsl2rgb, rgb2hsl, hex2rgb, rgb2hex } from '@scanex/color';
    import ColorArea from '../ColorArea/ColorArea.svelte';
    import AlphaSlider from '../AlphaSlider/AlphaSlider.svelte';
    import ColorSlider from '../ColorSlider/ColorSlider.svelte';
    import './ColorPicker.css';

    const rxHex = /#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})/gi;
    const rxRGB = /\d+\s*,\s*\d+\s*,\s*\d+/gi;

    const dispatch = createEventDispatcher();

    export let mode = 'hex';
    export let alpha = 100;
    export let hue = 0;
    export let saturation = 1.0;
    export let lightness = 0.5;

    let hex;
    $: {
        const {r, g, b} = hsl2rgb(hue, saturation, lightness);
        hex = rgb2hex(r,g,b);
    }

    let rgb;
    $: {
        const {r, g, b} = hsl2rgb(hue, saturation, lightness);
        rgb = [r,g,b].join(',');
    }

    let rgba;
    $: {
        const {r, g, b} = hsl2rgb(hue, saturation, lightness);
        const a = alpha / 100;
        rgba = `rgba(${[r,g,b,a].join(',')})`;
    }

    let sample;
    $: {
        if (sample) {
            sample.style.backgroundColor = rgba;
        }        
    }

    let box;
    $: {
        if(box) {
           switch(mode) {
                case 'hex':                    
                    box.value = hex;
                    break;
                case 'rgb':                    
                    box.value = rgb;
                    break;
                default:
                    break;
            }
        }
    }
    function toggle() {
        switch(mode) {
            case 'hex':
                mode = 'rgb';                
                break;
            case 'rgb':
                mode = 'hex';                
                break;
            default:
                break;
        }
    }
    
    function change (e) {        
        const value = box.value.trim();
        var {r,g,b} = {r: 0, g: 0, b: 0};
        if (mode === 'hex' && rxHex.test(value)) {
            var {r, g, b} = hex2rgb (value);
            const {h,s,l} = rgb2hsl (r,g,b);
            hue = h;
            saturation = s;
            lightness = l;
        }
        else if (mode === 'rgb' && rxRGB.test(value)) {
            var [r,g,b] = value.split(',').map(x => parseInt(x, 10));
            if (0 <= r && r <= 255 && 0 <= g && g <= 255 && 0 <= b && b <= 255) {
                const {h,s,l} = rgb2hsl (r,g,b);
                hue = h;
                saturation = s;
                lightness = l;
            }                    
        }
    }
    
    afterUpdate(() => {
        dispatch('change', hex);
    });
</script>

<table class="color-picker" on:click|stopPropagation on:dragstart|stopPropagation>
    <tr>
        <td>
            <span class="color-picker-sample" bind:this="{sample}"></span>
        </td>
        <td>
            <span class="color-picker-mode">{mode}</span>
            <input type="text" bind:this="{box}" class="color-picker-box" on:change="{change}" />
        </td>
        <td>
            <span class="color-picker-box-button" on:click|stopPropagation="{toggle}"></span>
        </td>
        <td>
        </td>
    </tr>
    <tr>
        <td colspan="3" class="color-area-container">
            <ColorArea bind:hue bind:saturation bind:lightness />
        </td>
        <td class="alpha-slider-container">
            <AlphaSlider bind:alpha bind:hue bind:saturation bind:lightness />
        </td>
    </tr>
    <tr>
        <td colspan="3" class="color-slider-container">
            <ColorSlider bind:hue />
        </td>
        <td>
        </td>
    </tr>    
</table>